import React, { useState } from "react";
import toast from "react-hot-toast";

import { usersApi } from "../../api";
import { useSubmitLock } from "../../hooks/useSubmitLock";
import "./ChangePasswordModal.css";

type Props = {
  token?: string | null;
  onClose: () => void;
};

export const ChangePasswordModal: React.FC<Props> = ({ token, onClose }) => {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [saving, setSaving] = useState(false);
  const { run } = useSubmitLock();

  const handleClose = () => {
    if (saving) return;
    onClose();
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    await run(async () => {
      if (!token) return;
      if (newPassword !== confirmNewPassword) {
        toast.error("New passwords do not match");
        return;
      }
      if (newPassword.length < 8) {
        toast.error("New password must be at least 8 characters");
        return;
      }
      setSaving(true);
      try {
        await usersApi.changePassword({ current_password: currentPassword, new_password: newPassword }, token);
        toast.success("Password updated");
        onClose();
      } catch (err) {
        toast.error(err instanceof Error ? err.message : "Could not change password");
      } finally {
        setSaving(false);
      }
    });
  };

  return (
    <div className="change-password-modal" role="presentation" onMouseDown={handleClose}>
      <div
        className="change-password-modal__dialog eventos-card"
        role="dialog"
        aria-modal="true"
        aria-label="Change password"
        onMouseDown={(e) => e.stopPropagation()}
      >
        <header className="change-password-modal__head">
          <div className="eventos-label">Change password</div>
          <button type="button" className="eventos-nav-btn" onClick={handleClose} disabled={saving}>
            Close
          </button>
        </header>
        <form onSubmit={handleSubmit} className="eventos-form">
          <label className="eventos-field">
            <span className="eventos-field-label">Current password</span>
            <input
              className="eventos-input"
              type="password"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              autoComplete="current-password"
              required
            />
          </label>
          <label className="eventos-field">
            <span className="eventos-field-label">New password</span>
            <input
              className="eventos-input"
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              autoComplete="new-password"
              minLength={8}
              required
            />
          </label>
          <label className="eventos-field">
            <span className="eventos-field-label">Confirm new password</span>
            <input
              className="eventos-input"
              type="password"
              value={confirmNewPassword}
              onChange={(e) => setConfirmNewPassword(e.target.value)}
              autoComplete="new-password"
              minLength={8}
              required
            />
          </label>
          <button className="eventos-primary-btn" type="submit" disabled={saving}>
            {saving ? "Updating…" : "Update password"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ChangePasswordModal;
